import { checkDeviceType } from '@/src/utils/browser'
import { useState, useCallback } from 'react'
import { SignInModalWrapper } from '@/src/components/common/header/variants/flyin/SignInModal'

interface UseRedirectToLoginOptions {
    controlledOpen?: boolean
    onModalStateChange?: (isOpen: boolean) => void
}

const useRedirectToLogin = (options?: UseRedirectToLoginOptions) => {
    const [internalOpen, setInternalOpen] = useState(false)

    const isControlled = options?.controlledOpen !== undefined
    const signInModalOpen = isControlled ? (options.controlledOpen ?? false) : internalOpen

    const goToLogin = useCallback(async () => {
        if (checkDeviceType() === 'AndroidApp') {
            window?.MobileApp?.GO_TO_LOGIN?.('')
        } else if (typeof window?.webkit?.messageHandlers['GO_TO_LOGIN'] == 'object') {
            window.webkit.messageHandlers['GO_TO_LOGIN'].postMessage('')
        } else {
            if (isControlled) {
                options?.onModalStateChange?.(true)
            } else {
                setInternalOpen(true)
            }
        }
    }, [isControlled, options])

    const handleSignInModalClose = useCallback(() => {
        if (isControlled) {
            options?.onModalStateChange?.(false)
        } else {
            setInternalOpen(false)
        }
    }, [isControlled, options])

    const SignInModalComponent = useCallback(() => {
        // Always render to preserve OTP flow state (control visibility with 'open' prop)
        return <SignInModalWrapper open={signInModalOpen} onClose={handleSignInModalClose} />
    }, [signInModalOpen, handleSignInModalClose])

    return {
        goToLogin,
        SignInModal: SignInModalComponent,
        signInModalOpen,
        setSignInModalOpen: isControlled ? options?.onModalStateChange : setInternalOpen
    }
}

export default useRedirectToLogin
